var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.showHeader ? 'page-main' : 'page-single']},[(_vm.showHeader)?_c('nav-bar'):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }